<template>
    <div>
        <p
            class="mb-1"
            :class="`text-${presentation.summary.color}`"
            role="status"
            aria-live="polite"
        >
            <strong>{{ presentation.summary.label }}</strong>
        </p>
        <p>{{ presentation.message }}</p>
        <ul v-if="presentation.vendors.length" class="vendor-status-list mb-0">
            <li v-for="vendor in presentation.vendors" :key="vendor.source">
                <span>{{ vendorName(vendor.source) }}</span>
                <span :class="`text-${appearance(vendor.status).color}`">
                    {{ appearance(vendor.status).label
                    }}<template v-if="vendor.failed && vendor.status !== 'error'">
                        · errors reported</template
                    >
                </span>
            </li>
        </ul>
        <p
            v-if="presentation.vendors.some((vendor) => vendor.status === 'queued')"
            class="status-note mb-0"
        >
            Vendors waiting to start may be processing another search. Their status updates
            automatically.
        </p>
        <p
            v-else-if="presentation.vendors.some((vendor) => vendor.status === 'pending')"
            class="status-note mb-0"
        >
            We're waiting for a vendor status update. This does not confirm a failure.
        </p>
    </div>
</template>

<script>
    import {
        describeLiveSearch,
        liveSearchAppearance,
        liveSearchVendorName,
    } from '@/services/liveSearchPresentation'

    export default {
        name: 'LiveSearchStatusContent',
        props: {
            runs: { type: Array, default: () => [] },
            loading: { type: Boolean, default: false },
            resumeFailed: { type: Boolean, default: false },
        },
        computed: {
            presentation() {
                return describeLiveSearch(this)
            },
        },
        methods: { appearance: liveSearchAppearance, vendorName: liveSearchVendorName },
    }
</script>

<style scoped>
    .vendor-status-list {
        list-style: none;
        padding: 0;
    }
    .vendor-status-list li {
        display: flex;
        justify-content: space-between;
        gap: 16px;
        padding: 6px 0;
    }
    .status-note {
        margin-top: 12px;
        font-size: 0.875rem;
        color: var(--bs-secondary-color, #555);
    }
    .text-warning {
        color: var(--bs-warning-text-emphasis, #664d03) !important;
    }
</style>
